import { useQuery } from '@tanstack/react-query';
import { fetchAllPages } from '@/lib/apiPaging';
import { isPendingScan } from '@/lib/ocrScans';
import { qk } from '@/lib/qk';

// Equivalente de servidor de `isPendingScan` (L-02a §3.1): OCR terminado de forma
// utilizable y sin ninguna salida (gasto, factura, nómina o documento).
export const OCR_PENDIENTES_FILTROS = { status: 'completed,review_needed', linked: 'false' };

/**
 * Escaneos OCR pendientes de la Bandeja, compartidos por la página y el contador del
 * menú (L-02b §3.3). Antes ambos pedían `/api/ocr-scans` sin filtros (100 filas) y
 * filtraban en cliente: con más de 100 escaneos, los pendientes antiguos
 * desaparecían de la Bandeja y del contador.
 *
 * El filtro se repite en cliente para decidir bien también contra un backend que
 * aún no filtre. `count` es exacto salvo truncado; entonces se usa el `total` del
 * servidor y `truncated` avisa.
 */
export function useOcrPendientes(companyId, { enabled = true } = {}) {
  return useQuery({
    queryKey: qk.ocrScan.pendientes(companyId),
    queryFn: async () => {
      const { items, total, truncated } = await fetchAllPages('/api/ocr-scans', { filters: OCR_PENDIENTES_FILTROS });
      const pendientes = items.filter(isPendingScan);
      return { pendientes, count: truncated ? total : pendientes.length, truncated };
    },
    enabled: !!companyId && enabled,
    staleTime: 60 * 1000,
  });
}
